<template>
    <div class="calendar-event-list-view">
        <div class="groups">
            <div class="group" v-for="group in getGroups()" :key="group.date">
                <div class="group-title">
                    {{ group.dateLabel }}
                </div>
                <div
                    class="event"
                    v-for="event in group.events"
                    :key="event._id"
                    @click.prevent="getEventDetail(event)"
                >
                    <div class="hour">
                        {{ getEventHourRange(event) }}
                    </div>
                    <div class="metas">
                        <div class="left">
                            <AgentAvatar :size="25" :userID="event.userId" :font-size="15" />
                        </div>
                        <div class="right">
                            <strong>{{ event.summary }}</strong>
                            <span v-if="!!event.reservationId"> {{ getFullname(event) }}</span>
                            <span v-else> {{ event.description }}</span>
                        </div>
                    </div>
                    <div class="attendees">
                        <AgentAvatar
                            v-for="refUser in event.refUsers"
                            :key="refUser._id"
                            :size="25"
                            :font-size="15"
                            :userID="refUser._id"
                        />
                    </div>
                </div>
            </div>
        </div>
        <CreateEventModal
            :calendarList="calendarList"
            v-if="modalVisible"
            @close="modalVisible = false"
            :eventDetail="eventDetail"
            :footerVisible="false"
            @deleteEvent="deleteEvent"
        />
    </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
import moment from "moment";
import AgentAvatar from "../../../../../components/common/AgentAvatar.vue";
import CreateEventModal from "../CreateEventModal.vue";
import { mapActions, mapGetters } from "vuex";
import { PERMISSION_TYPES } from "../../../../../language/permissionTypes";

export default Vue.extend({
    name: "CalendarEventListview",
    components: { CreateEventModal, AgentAvatar },
    props: {
        events: {
            type: Array,
            default: () => [],
        },
        groupByDate: {
            type: Boolean,
            default: true,
        },
        calendarList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            modalVisible: false,
            eventDetail: {},
        };
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        calendarUpdatePermission() {
            return this.checkPermission(PERMISSION_TYPES["calendar.update"].tr.name);
        },
    },
    methods: {
        ...mapActions({
            getEventDetailAction: "calendar/getEventDetail",
        }),
        getFullname(event) {
            return (
                event.formValues.find((f) => f.label === "name").value +
                " " +
                event.formValues.find((f) => f.label === "surname").value
            );
        },
        deleteEvent() {
            this.events = this.events.filter((e) => e._id !== this.eventDetail._id);
            this.modalVisible = false;
        },
        async getEventDetail(event) {
            if (this.calendarUpdatePermission) {
                this.eventDetail = await this.getEventDetailAction(event._id);
                this.modalVisible = true;
            } else {
                this.$message.error(this.$t("noPermission"));
            }
        },
        getEventHourRange(event) {
            return `${moment(event.start).format("HH:mm")} - ${moment(event.end).format("HH:mm")}`;
        },
        getGroups() {
            if (this.groupByDate) {
                const groups = _.groupBy(this.events, (e) => moment(e.start).format("YYYY-MM-DD"));
                return Object.keys(groups).map((key) => {
                    return {
                        date: key,
                        dateLabel: moment(key).format("DD MMMM YYYY"),
                        events: groups[key],
                    };
                });
            } else {
                return [
                    {
                        date: "",
                        dateLabel: "",
                        events: this.events,
                    },
                ];
            }
        },
    },
    mounted() {
        console.log("CalendarEventListview mounted", { events: this.events });
    },
});
</script>

<style lang="scss">
.calendar-event-list-view {
    .vue-avatar--wrapper {
        font-size: 12px !important;
    }

    .groups {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .group {
            font-size: 14px;
            font-weight: 400;
            color: var(--color-text-default);
            border: 1px solid var(--color-border-default);
            border-radius: 8px;
            padding-top: 10px;
            display: flex;
            flex-direction: column;
            width: 100%;
            background: var(--color-bg-default);

            .group-title {
                font-weight: 700;
                color: var(--color-text-strong-default);
                padding: 0 20px;
            }

            .event {
                display: flex;
                align-items: center;

                padding: 10px 20px;
                width: 100%;
                border-bottom: 1px solid var(--color-border-default);
                cursor: pointer;
                align-items: flex-start;

                &:hover {
                    background: var(--color-bg-primary-subdued-hover);
                }

                .hour {
                    font-size: 12px;
                    font-weight: 400;
                    color: var(--color-text-default);
                    padding: 0 10px;
                    display: flex;
                    width: 100px;
                    justify-content: flex-start;
                    align-items: flex-start;
                }

                .metas {
                    width: calc(100% - 150px);
                    display: flex;
                    gap: 10px;

                    .left {
                        justify-content: flex-start;
                    }

                    .right {
                        display: flex;
                        flex-direction: column;
                        gap: 2px;
                    }
                }

                .attendees {
                    display: flex;
                    gap: 5px;
                    min-width: 50px;
                    justify-content: flex-end;
                }
            }
        }
    }
}
</style>
